/**
* @NApiVersion 2.x
* @NModuleScope TargetAccount
* // Copyright (c) 2021, Oracle and/or its affiliates. All rights reserved.
* // Licensed under the Universal Permissive License v 1.0 as shown at http://oss.oracle.com/licenses/upl.
*/
define([
    'N/record',
    'N/runtime',
    'N/search',
    'N/render',
    'N/email',
	'N/error'
], function (
    record,
    runtime,
    search,
	render,
	email,
	error
) {
    'use strict';

    var ProductDetailsGridOrderModel = {

        get: function (internalid) {
            // var itemID = internalid;
            var recordType = 'customrecordcs_item_variant';
            var searchResults;
            var mappedResults = new Array();
            var resultObj = new Object();
            var filters = new Array();

            log.error('itemID', JSON.stringify(internalid));

            if (internalid) {
                filters = [{
                    name: 'isinactive',
                    operator: search.Operator.IS,
                    values: 'F'
                }, {
                    name: 'custrecordcs_item_name',
                    operator: search.Operator.ANYOF,
                    values: internalid // Fullfilled
                }]
            }

            log.error('filters', JSON.stringify(filters));

            var columns = [
                'internalid', 
                'custrecordcs_item_name', 
                'custrecordcs_level_variant', 
                'custrecordcs_shade', 
                'custrecordcs_mould'
            ];

            searchResults = search.create({
                type: recordType,
                filters: filters,
                columns: columns
            }).run().each(function each(result) {
                mappedResults.push({
                    internalid: result.getValue('internalid'),
                    itemname: result.getValue('custrecordcs_item_name'),
                    variants: result.getText('custrecordcs_level_variant'),
                    shade: result.getValue('custrecordcs_shade'),
                    mould: result.getValue('custrecordcs_mould')
                });

                return true;
            });

            log.error('mappedResults', JSON.stringify(mappedResults));

            for (var _i = 0, mapped = mappedResults; _i < mapped.length; _i++) {
                var _a = mapped[_i], 
                variants = _a.variants, 
                internalid = _a.internalid,
                itemname = _a.itemname,
                shade = _a.shade,
                mould = _a.mould;
                    if (!resultObj[variants])
                        resultObj[variants] = [];
                        resultObj[variants].push({ 
                            internalid: internalid, 
                            itemname: itemname, 
                            shade: shade,
                            mould: mould
                    })
            }

            log.error('resultObj', JSON.stringify(resultObj));

            return {
                itemVariants: resultObj.length == 1 ? resultObj[0] : resultObj
            };
        }
    }

    return ProductDetailsGridOrderModel
})
